import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-2" }, " パスワードの設定（初期設定または忘れてしまった場合の再設定） ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-full mx-auto text-center text-sm text-gray-500 mb-12" }, [
  /*#__PURE__*/_createTextVNode(" 「パスワード設定メールを送信」ボタンを押すと、パスワード設定メールが届きます。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("そちらに記載のURLより、新しいパスワードを設定してください。 ")
], -1)
const _hoisted_5 = { class: "w-3/4 mb-8" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" パスワード設定メールを送信 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "メールアドレス",
          name: "email",
          type: "email",
          placeholder: "example@mingaku.net",
          invalid: !_ctx.validEmail,
          "invalid-message": "正しいメールアドレスを入力してください",
          entered: _ctx.enteredEmail,
          value: _ctx.email,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
          onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredEmail = true))
        }, null, 8, ["invalid", "entered", "value"])
      ]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        "font-size": "base",
        disabled: !_ctx.validEmail && _ctx.allEntered,
        onClick: _ctx.resetPassword
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}